module.exports = __webpack_public_path__ + "static/media/background-clean.dd646edb.svg";